export enum Occupation{
  //TODO: used to be lower case, we will have to figure out visual displaying of enums
  PIPE_FITTER = 'PIPE_FITTER',
  WELDER = 'WELDER'
}
